export default "__VITE_ASSET__Dxl1DJTC__"